import {createSelector} from "@reduxjs/toolkit";
import {blogsCategoriesSelector, blogsDataSelector, blogsStatusSelector} from "./blogsSlice";
import {isEmpty} from "es-toolkit/compat";

export const selectBlogsData = createSelector([blogsDataSelector], data => (!isEmpty(data) ? data : {}));

export const selectLatestBlogsData = createSelector([blogsDataSelector], data => {
  if (isEmpty(data)) return [];
  return data.latestPosts?.results || [];
});

export const selectLatestBlogsMeta = createSelector([blogsDataSelector], data => {
  if (isEmpty(data)) return {};
  return data.latestPosts?.meta || {};
});

export const selectForYouBlogsData = createSelector([blogsDataSelector], data => {
  if (isEmpty(data)) return [];
  return data.forYouPosts?.results || [];
});

export const selectForYouBlogsMeta = createSelector([blogsDataSelector], data => {
  if (isEmpty(data)) return {};
  return data.forYouPosts?.meta || {};
});

export const selectSavedBlogs = createSelector([blogsDataSelector], data => {
  if (isEmpty(data)) return [];
  return data.savedPosts || [];
});

export const selectBlogsCategories = createSelector([blogsCategoriesSelector], categories =>
  !isEmpty(categories) ? categories : [],
);
export const selectBlogsStatus = createSelector([state => state.blogs], state => ({
  hasFailed: state.hasFailed,
  isFetching: state.isFetching,
  errorMsg: state.errorMsg,
}));
